import { Modal } from 'bootstrap'

document.addEventListener('DOMContentLoaded', function (e) {
    const notification = document.querySelector('.part-notification')
    let notificationIsClose = JSON.parse(sessionStorage.getItem('notification-is-close'))

    // Fonction pour mettre à jour la variable CSS --notificationbar-height
    function updateNotificationHeight() {
        const height = notificationIsClose || !notification ? 0 : notification.offsetHeight;
        document.body.style.setProperty('--notificationbar-height', `${height}px`);
    }

    if (notification) {
        const notificationClose = notification.querySelector('.js-close-notification')

        window.addEventListener('load', updateNotificationHeight);
        window.addEventListener('resize', updateNotificationHeight);

        if (notificationClose) {
            if (notificationIsClose) {
                notification.style.display = 'none'
            }
            notificationClose.addEventListener('click', function () {
                sessionStorage.setItem('notification-is-close', 'true')
                notification.style.display = 'none'
                notificationIsClose = true

                // Mettre à jour la hauteur après la fermeture
                updateNotificationHeight();
            })
        }
    }
    else {
        document.body.style.setProperty('--notificationbar-height', `0px`);
    }

    const modalElement = document.getElementById('adsModal')
    let popupIsClose = JSON.parse(sessionStorage.getItem('popup-is-close'))

    if (modalElement) {
        const adsModal = new Modal(modalElement)

        if (!popupIsClose) {
            setTimeout(() => {
                adsModal.show()
            }, 3000)
        }

        // Remplace $('#adsModal').on('hidden.bs.modal', ...)
        modalElement.addEventListener('hidden.bs.modal', function () {
            sessionStorage.setItem('popup-is-close', 'true')
            popupIsClose = true
        })
    }
})